import { certService } from '../../helpers/services/productRegistrationCert.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper, sessionHelper } from '@/utils'
import { SESSION } from "@/constants";
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const PRODUCT_CERT_MODULE = 'productRegistrationCert'; 

// define action 
export const GET_ALL_PRODUCT_CERTS = 'getAllProductCerts';
export const GET_PRODUCT_CERT = 'getProductCert';
export const UPDATE_PRODUCT_CERT = 'updateProductCert';
export const CREATE_PRODUCT_CERT = 'createProductCert';
export const UPDATE_PRODUCT_CERT_STATUS = 'updateProductCertStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_PRODUCT_CERTS_REQUEST = "getAllProductCerts";
const GET_PRODUCT_CERT_REQUEST = "getProductCert";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    async [GET_ALL_PRODUCT_CERTS]({ commit }, { filter }) {
       await certService
            .getAllCerts(filter)
            .then(
                (result) => {
                    commit(GET_ALL_PRODUCT_CERTS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_PRODUCT_CERT]({ commit }, { id }) {
        certService
            .getCert(id)
            .then(
                (result) => {
                    commit(GET_PRODUCT_CERT_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_CERT]({ commit }, { data, isCloseWhenSuccess }) {
        commit(REQUEST)
        certService
            .updateCert(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    commit(SUCCESS, isCloseWhenSuccess)

                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.productRegisterationCertification')]);
                    if(isCloseWhenSuccess == false) {
                        sharedHelper.alertSuccessMessage(message)
                    }
                    else {
                        sharedHelper.alertSuccessMessageAndClose(message)
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_PRODUCT_CERT]({ commit }, { data, isCloseWhenSuccess }) {
        commit(REQUEST)
        certService
            .createCert(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    commit(SUCCESS, isCloseWhenSuccess)

                    var message = i18n.t("message.createXSuccess", [i18n.t('module.productRegisterationCertification')]);
                    if(isCloseWhenSuccess == false) {
                        sharedHelper.alertSuccessMessage(message)
                    }
                    else {
                        sharedHelper.alertSuccessMessageAndClose(message)
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_CERT_STATUS]({ dispatch }, { filter, data }) {
        certService
            .updateCertStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_PRODUCT_CERTS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state, isCloseWhenSuccess) {
        state.status = {};
        if(isCloseWhenSuccess == false) {
            router.push({ name: "Product-cert-listing" });
        }
        else {
            sessionHelper.clearSearch(SESSION.PRODUCT_SPECIAL_SEARCH)
        }
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_PRODUCT_CERTS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                imageURL: o.image_url,
                product: o.product,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_PRODUCT_CERT_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            name: o.name,
            file: o.image_url,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at),
            productID: o.product != null ? {
                value: o.product.uuid,
                text: o.product.name
            } : '',
        }

    }
}


